import { useOrgRole } from "@/hooks/useOrganization";
import { Navigate } from "react-router-dom";
import type { ReactNode } from "react";

export default function OrgProtectedRoute({ children }: { children: ReactNode }) {
  const { isAdmin, orgId } = useOrgRole();

  if (!orgId || !isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
